import { render, staticRenderFns } from "./SwitchAccount.vue?vue&type=template&id=1c17a20f&"
import script from "./SwitchAccount.vue?vue&type=script&lang=ts&"
export * from "./SwitchAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports